/**
 * Maps KAI template-customizer write tools to live preview draft patches.
 */

const FOOTER_CSS_KEYS = [
  "footerBackground",
  "footerMainText",
  "footerCopyRightBackground",
  "footerCopyRightText",
  "footerSubText",
  "footerHeight",
];

const HEADER_CSS_KEYS = [
  "topBarBackground",
  "topBarText",
  "headerBackground",
  "headerText",
  "headerHeight",
];

const HEADER_DATA_KEYS = [
  "megaMenu",
  "companyName",
  "saleTitle",
  "contactLine",
  "contactNumber",
  "navigation",
];

function pickDefined(obj, keys) {
  const out = {};
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") out[k] = obj[k];
  }
  return Object.keys(out).length ? out : null;
}

function slugify(name) {
  return String(name || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

function normalizeMegaNode(item) {
  if (!item || typeof item !== "object") return null;
  const name = String(item.name ?? item.title ?? "").trim();
  if (!name) return null;
  const rawSubs = item.subCategories ?? item.children ?? [];
  const subCategories = Array.isArray(rawSubs)
    ? rawSubs.map(normalizeMegaNode).filter(Boolean)
    : [];
  const url = String(item.url ?? "").trim() || `/category/${slugify(name)}`;
  return {
    id: item.id || `mega-${slugify(name)}-${Math.random().toString(36).slice(2, 8)}`,
    name,
    url: url.startsWith("/") || url.startsWith("http") ? url : `/${url}`,
    type: item.type || "Link",
    ...(subCategories.length > 0 ? { subCategories } : {}),
  };
}

export function kaiActionToTemplateDraftPatch(tool, args = {}) {
  if (!tool || !args) return null;

  switch (tool) {
    case "update_template_fonts": {
      const fonts = {};
      if (args.headingfontstyle) fonts.headingfontstyle = args.headingfontstyle;
      if (args.contentfontstyle) fonts.contentfontstyle = args.contentfontstyle;
      return Object.keys(fonts).length ? { fonts } : null;
    }
    case "update_template_footer_css": {
      const footerCss = pickDefined(args, FOOTER_CSS_KEYS);
      return footerCss ? { footerCss } : null;
    }
    case "update_template_header_css": {
      const headerCss = pickDefined(args, HEADER_CSS_KEYS);
      return headerCss ? { headerCss } : null;
    }
    case "update_template_header": {
      const headerData = pickDefined(args, HEADER_DATA_KEYS);
      if (!headerData) return null;
      const patch = { headerData };
      if (args.megaMenu === false) patch.megaMenu = [];
      return patch;
    }
    case "update_template_mega_menu": {
      if (!Array.isArray(args.items) || args.items.length === 0) return null;
      const megaMenu = args.items.map(normalizeMegaNode).filter(Boolean);
      if (!megaMenu.length) return null;
      return {
        megaMenu,
        headerData: { megaMenu: true },
      };
    }
    default:
      return null;
  }
}

export function isTemplateDraftApplicableWrite(tool) {
  return [
    "update_template_fonts",
    "update_template_footer_css",
    "update_template_header_css",
    "update_template_header",
    "update_template_mega_menu",
  ].includes(tool);
}
